import { IEquipment, IEquipmentProps, IEquipmentStates } from "./interfaces";
import { BaseComponent } from "../../components/infrastructure/baseComponent";
import { Button, Col, Descriptions, Tabs, Tooltip, Tree } from "antd";
import { DataNode } from "antd/lib/tree";
import { Key } from "react";
import { EquipmentItem } from "./equipmentItem";
import { ICallOptions, IFetchingInfo } from "../../components/infrastructure/models";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { enmEntityManagerState, IInitialData } from "../../components/entityManager/interfaces";
import { PlusCircleOutlined, OrderedListOutlined, LinkOutlined, StopOutlined } from '@ant-design/icons';
import EquipmentDocumentType from "./equipmentDocumentType";
import EquipmentSendingItem from "./equipmentSendingItem";
import { EquipmentModel } from "../equipmentModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReply } from "@fortawesome/free-solid-svg-icons";
import EquipmentProblem from "./equipmentProblem";
const { TabPane } = Tabs;

export class Equipment extends BaseComponent<IEquipmentProps, IEquipmentStates>{
    rootNode: DataNode;
    equipmentItem?: EquipmentItem | null;
    equipmentModel?: EquipmentModel | null;

    constructor(props: IEquipmentProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            equipments: [],
            selectedItem: this.props.params && this.props.params()?.parent,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
        this.rootNode = {
            key: 0,
            title: "درخت تجهیزات",
            children: []
        };
        this.title = "درخت تجهیزات";
    }
    componentDidMount() {
        super.componentDidMount();
        this.loadData();
    }
    async loadData() {
        let fetchingInfo: IFetchingInfo = {
            Paging: { PageNo: 1, PageSize: 100 },
            Orderings: []
        };
        let parentId = this.props.params && this.props.params().parent?.Id;
        if (parentId)
            fetchingInfo.Filter = ComparisonFilter.Equal<IEquipment>(e => e.ParentId, parentId);
        let opt: ICallOptions = {
            url: 'equipment/get',
            data: { fetchingInfo },
            onSuccess: (result) => {
                if (result.ValidationState.Successful) {
                    let data: IEquipment[] = (result as any).Data;
                    if (this.mounted) {
                        this.setState({
                            loading: false,
                            equipments: data
                        });
                    }
                }
            }
        };
        await this.callApi(opt);
    }
    getHeader = (initialData?: IInitialData) => {
        if (initialData) {
            const extra: React.ReactNode[] = [];
            if (this.equipmentItem) {
                //if (this.equipmentItem.state.state === enmEntityManagerState.List)
                //    extra.push(<Search key="1" placeholder="جستجو" allowClear={true} style={{ width: 200 }} loading={this.state.loading}
                //        onSearch={(value) => {
                //            this.equipmentItem?.search(value);
                //        }} />);
                if (this.equipmentItem.state.state === enmEntityManagerState.List && initialData?.AccessList["Add"])
                    extra.push(<Tooltip key="2" title={"ایجاد " + this.equipmentItem.metadata.title + " جدید"}><Button style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '100px' }} type="primary" onClick={() => this.equipmentItem?.add()} icon={<PlusCircleOutlined />}>ایجاد</Button></Tooltip>);
            }

            const header = this.getPageHeader({
                title: "تجهیزات",
                onBack: () => {
                    if (this.props.onClose)
                        this.props.onClose(this);
                    else
                        window.history.back();
                }, extraHeaderButtons: extra,
                extraHeaderNodes: this.extraHeaderNodes()
            });
            return header;
        }
    }
    renderEquipments(equipments: IEquipment[], parentId?: number): DataNode[] {
        let nodes: DataNode[] = [];
        equipments.filter(c => c.ParentId === (parentId ?? null))
            .forEach(c => {
                if (c.Name === "Home")
                    return;
                let key = c.Id;
                let node: DataNode = {
                    key: key,
                    title: c.Name,
                };
                let children = this.renderEquipments(equipments, c.Id);
                if (children.length)
                    node.children = children;
                nodes.push(node);
            });
        return nodes;
    }
    onSelect = (selectedkeys: React.Key[]) => {
        if (selectedkeys.length) {
            let selectedItem = this.state.equipments.find(e => e.Id === selectedkeys[0]);
            this.setState({ selectedItem });
        }
        else
            this.setState({ selectedItem: undefined });

    }
    componentDidUpdate(_: Readonly<IEquipmentProps>, prevState: Readonly<IEquipmentStates>) {
        if (prevState.selectedItem?.Id !== this.state.selectedItem?.Id) {
            this.equipmentItem?.fetchData();
            this.equipmentModel?.fetchData();
        }
    }
    extraHeaderNodes = () => {
        let name = this.state.selectedItem?.Name ?? "درخت تجهیزات";
        let label = !this.state.selectedItem || this.state.selectedItem.IsGroup ? "نام گروه اصلی" : "نوع تجهیز";
        return (
            <Descriptions className="header-page">
                <Descriptions.Item label={label}>{name}</Descriptions.Item>
            </Descriptions>
        );
    }
    virtualRender() {
        this.rootNode.children?.splice(0);
        const nodes: DataNode[] = this.renderEquipments(this.state.equipments);
        let expandedKeys: React.Key[] = [0];
        this.state.equipments.forEach(c => {
            if (expandedKeys.indexOf(c.Id) === -1)
                expandedKeys.push(c.Id);
        });

        this.rootNode.children!.push(...nodes);
        const selectedKeys: Key[] = [];
        if (this.state.selectedItem)
            selectedKeys.push(this.state.selectedItem.Id);
        else
            selectedKeys.push(0);

        let header = this.getHeader(this.state.equipmentItemInitialData);

        return (
            <>
                {header}
                <div key="equipments-container" className="row" style={{ margin: 0 }} >
                    <div key="equipments-tree" className="col-md-4"
                        style={{
                            margin: 0,
                            padding: 0,
                            paddingBottom: this.state.windowSize === 1 ? 10 : 0
                        }}>
                        <div className="box">
                            <Tree
                                selectable
                                showLine={true}
                                treeData={[this.rootNode]}
                                selectedKeys={selectedKeys}
                                expandedKeys={expandedKeys}
                                onSelect={this.onSelect}
                                style={{ padding: 10, overflowX: "auto" }}
                            />
                        </div>
                    </div>
                    <div key="equipments-grid" className="col-md-8"
                        style={{
                            margin: 0,
                            padding: 0,
                            paddingRight: this.state.windowSize === 1 ? 0 : 10
                        }}>
                        {this.state.selectedItem?.IsGroup === false ?
                            <div className="box">
                                <Tabs defaultActiveKey="1">
                                    <TabPane
                                        tab={
                                            <span style={{ marginRight: 4 }}>
                                                <LinkOutlined />
                                                مستندات لازم جهت ثبت خسارت
                                            </span>
                                        }
                                        key="1"
                                        style={{ margin: 10 }}
                                    >
                                        <EquipmentDocumentType
                                            parent={this}
                                            params={() => {
                                                return { equipment: this.state.selectedItem! };
                                            }}
                                        />
                                    </TabPane>
                                    <TabPane
                                        tab={
                                            <span>
                                                <OrderedListOutlined />
                                                موارد ارسالی جهت پیگیری خسارت
                                            </span>
                                        }
                                        key="2"
                                        style={{ margin: 10 }}
                                    >
                                        <EquipmentSendingItem
                                            parent={this}
                                            params={() => {
                                                return { equipment: this.state.selectedItem! };
                                            }}
                                        />
                                    </TabPane>
                                    <TabPane
                                        tab={
                                            <span>
                                                <OrderedListOutlined />
                                                مدل ها
                                            </span>
                                        }
                                        key="3"
                                    >

                                        <EquipmentModel
                                            key="EquipmentModel"
                                            preLoad={true}
                                            params={() => {
                                                return { equipment: this.state.selectedItem! }
                                            }}
                                            ref={node => this.equipmentModel = node}
                                            backNode={state => {
                                                if (state === enmEntityManagerState.List)
                                                    return (<></>);
                                                else
                                                    return (
                                                        <Tooltip title="لغو/بازگشت" >
                                                            <FontAwesomeIcon key="back-icon"
                                                                className="back-color"
                                                                icon={faReply}
                                                                transform={{ flipX: true }}
                                                                size={'xl'}
                                                                style={{ margin: 10 }}
                                                                onClick={() => this.equipmentModel?.back()}
                                                            />
                                                        </Tooltip>
                                                    )
                                            }}
                                            style={{ background: "#eeeeee", padding: 0 }}
                                            dataformBoxShadow={false}
                                        />
                                    </TabPane>

                                    <TabPane
                                        tab={
                                            <span>
                                                <OrderedListOutlined />
                                               مشکلات 
                                            </span>
                                        }
                                        key="4"
                                        style={{ margin: 10 }}
                                    >
                                        <EquipmentProblem
                                            parent={this}
                                            params={() => {
                                                return { equipment: this.state.selectedItem! };
                                            }}
                                        />
                                    </TabPane>
                                </Tabs>
                            </div>
                            :
                            <EquipmentItem params={() => {
                                return { parent: this.state.selectedItem }
                            }}
                                ref={node => this.equipmentItem = node}
                                onEntitySaved={() => this.loadData()}
                                onLoaded={(initialData) => this.setState({ equipmentItemInitialData: initialData })}
                                onStateChanged={() => this.setState({ equipmentItemInitialData: this.equipmentItem?.initialData })}
                                showHeader={false}
                                extraViewNode={() =>
                                    <Col className="box" style={{ width: "100%", textAlign: "left" }}>
                                        <Button type="ghost" onClick={() => this.equipmentItem?.back()} icon={<StopOutlined />} loading={this.state.loading} style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: "100px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }}>
                                            لغو
                                        </Button>
                                    </Col>
                                }
                            />
                        }
                    </div>
                </div>
            </>
        );
    }
}
